/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    CoverLevelLabelPrivateMotor: {
        id: 'cep.components.sgLobSpecifics.CoverLevel',
        defaultMessage: 'Cover Level'
    },
    CoverLevelLabelPrivateHome: {
        id: 'cep.components.sgLobSpecifics.TypeOfCover',
        defaultMessage: 'Type of cover'
    },
    CoverLevelLabelPrivateMedical: {
        id: 'cep.components.sgLobSpecifics.HealthPlan',
        defaultMessage: 'Health plan'
    },
    CoverLevelLabelPrivateTravel: {
        id: 'cep.components.sgLobSpecifics.CoverLevelTravel',
        defaultMessage: 'Cover level'
    },
    EndDate: {
        id: 'cep.components.sgLobSpecifics.EndDate',
        defaultMessage: 'End date'
    },
    Destination: {
        id: 'cep.components.sgLobSpecifics.Destination',
        defaultMessage: 'Destination'
    },
    DestinationSeeACompleteList: {
        id: 'cep.components.sgLobSpecifics.DestinationSeeACompleteList',
        defaultMessage: '{destinationsAfterJoin} +{hiddenCountriesCount} (To see a complete list of destinations please check \'My Documents\')'
    },
    Region: {
        id: 'cep.components.sgLobSpecifics.Region',
        defaultMessage: 'Region'
    },
    RegionEurope: {
        id: 'cep.components.sgLobSpecifics.RegionEurope',
        defaultMessage: 'Europe'
    },
    RegionWorldIncl: {
        id: 'cep.components.sgLobSpecifics.RegionWorldIncl',
        defaultMessage: 'Worldwide including U.S.A., Canada, Mexico and all Caribbean Islands'
    },
    RegionWorldExcl: {
        id: 'cep.components.sgLobSpecifics.RegionWorldExcl',
        defaultMessage: 'Worldwide excluding U.S.A., Canada, Mexico and all Caribbean Islands'
    },
    ForMotorInsurance: {
        id: 'cep.components.sgLobSpecifics.ForMotorInsurance',
        defaultMessage: 'Motor Insurance'
    },
    ForHomeInsurance: {
        id: 'cep.components.sgLobSpecifics.ForHomeInsurance',
        defaultMessage: 'Home Insurance'
    },
    ForTravelInsurance: {
        id: 'cep.components.sgLobSpecifics.ForTravelInsurance',
        defaultMessage: 'Travel Insurance'
    },
    ForHealthInsurance: {
        id: 'cep.components.sgLobSpecifics.ForHealthInsurance',
        defaultMessage: 'Health Insurance'
    },
    OpenLines: {
        id: 'cep.components.sgLobSpecifics.OpenLines',
        defaultMessage: 'Our lines are open:'
    },
    OpenLinesHomeMotor1: {
        id: 'cep.components.sgLobSpecifics.OpenLinesHomeMotor1',
        defaultMessage: '8.30am to 8pm weekdays'
    },
    OpenLinesHomeMotor2: {
        id: 'cep.components.sgLobSpecifics.OpenLinesHomeMotor2',
        defaultMessage: '9am to 5pm weekends'
    },
    OpenLinesTravel1: {
        id: 'cep.components.sgLobSpecifics.OpenLinesTravel1',
        defaultMessage: '08:30am to 7pm weekdays'
    },
    OpenLinesTravel2: {
        id: 'cep.components.sgLobSpecifics.OpenLinesTravel2',
        defaultMessage: '08:30am to 5pm Saturday'
    },
    OpenLinesHealth1: {
        id: 'cep.components.sgLobSpecifics.OpenLinesHealth1',
        defaultMessage: '8.30am to 7pm weekdays'
    },
    OpenLinesHealth2: {
        id: 'cep.components.sgLobSpecifics.OpenLinesHealth2',
        defaultMessage: '9am to 1pm Saturday'
    },
    RenewLabel: {
        id: 'cep.components.sgLobSpecifics.RenewLabel',
        defaultMessage: 'Renew now'
    },
    RenewFixedPriceLabel: {
        id: 'cep.components.sgLobSpecifics.RenewFixedPriceLabel',
        defaultMessage: 'Renew with 3-year fixed'
    },
    RenewSagaPlusLabel: {
        id: 'cep.components.sgLobSpecifics.RenewSagaPlusLabel',
        defaultMessage: 'Renew with Saga Plus'
    },
    ContinueLabel_WOC3143: {
        id: 'cep.components.sgLobSpecifics.ContinueLabel_WOC3143',
        defaultMessage: 'Continue'
    },
    HowToMakeClaimName: {
        id: 'cep.components.sgLobSpecifics.HowToMakeClaimName',
        defaultMessage: 'HowToMakeClaim'
    },
    HowToMakeClaimHeader: {
        id: 'cep.components.sgLobSpecifics.HowToMakeClaimHeader',
        defaultMessage: 'How to make a car insurance claim'
    },
    HowToMakeClaimDescription: {
        id: 'cep.components.sgLobSpecifics.HowToMakeClaimDescription',
        defaultMessage: 'We understand that making a claim can be stressful, so we aim to make it as simple and straightforward as possible.'
    },
    CarInsuranceForWomenName: {
        id: 'cep.components.sgLobSpecifics.CarInsuranceForWomenName',
        defaultMessage: 'CarInsuranceForWomen'
    },
    CarInsuranceForWomenHeader: {
        id: 'cep.components.sgLobSpecifics.CarInsuranceForWomenHeader',
        defaultMessage: 'Car insurance for women'
    },
    CarInsuranceForWomenDescription: {
        id: 'cep.components.sgLobSpecifics.CarInsuranceForWomenDescription',
        defaultMessage: 'It depends – the days of automatic discounts for women drivers are long gone. But there are ways everyone can save.'
    },
    BookingCarServiceName: {
        id: 'cep.components.sgLobSpecifics.BookingCarServiceName',
        defaultMessage: 'BookingCarService'
    },
    BookingCarServiceHeader: {
        id: 'cep.components.sgLobSpecifics.BookingCarServiceHeader',
        defaultMessage: 'How to get a good deal on car servicing'
    },
    BookingCarServiceDescription: {
        id: 'cep.components.sgLobSpecifics.BookingCarServiceDescription',
        defaultMessage: 'Find the right service for you using our handy guide to achieving a balanced car servicing schedule.'
    },
    CarsForOlderDriversName: {
        id: 'cep.components.sgLobSpecifics.CarsForOlderDriversName',
        defaultMessage: 'CarsForOlderDrivers'
    },
    CarsForOlderDriversHeader: {
        id: 'cep.components.sgLobSpecifics.CarsForOlderDriversHeader',
        defaultMessage: 'The best cars for older drivers'
    },
    CarsForOlderDriversDescription: {
        id: 'cep.components.sgLobSpecifics.CarsForOlderDriversDescription',
        defaultMessage: 'As we get older, our driving habits understandably change. So which are the best cars for older drivers? Get some inspiration in this handy Saga guide.'
    },
    DrivingOtherCarsName: {
        id: 'cep.components.sgLobSpecifics.DrivingOtherCarsName',
        defaultMessage: 'DrivingOtherCars'
    },
    DrivingOtherCarsHeader: {
        id: 'cep.components.sgLobSpecifics.DrivingOtherCarsHeader',
        defaultMessage: 'Think you\'re covered to drive another car?'
    },
    DrivingOtherCarsDescription: {
        id: 'cep.components.sgLobSpecifics.DrivingOtherCarsDescription',
        defaultMessage: 'Just because you have comprehensive car insurance doesn\'t mean you can automatically drive another car third party on the same cover.'
    },
    BoilerServiceName: {
        id: 'cep.components.sgLobSpecifics.BoilerServiceName',
        defaultMessage: 'BoilerService'
    },
    BoilerServiceHeader: {
        id: 'cep.components.sgLobSpecifics.BoilerServiceHeader',
        defaultMessage: 'Make the most of your boiler'
    },
    BoilerServiceDescription: {
        id: 'cep.components.sgLobSpecifics.BoilerServiceDescription',
        defaultMessage: 'Brrr, it\'s cold out there! Keep your home toasty and fuel-efficient with a few simple boiler maintenance tips. Follow our step-by-step boiler care guide to avoid costly callouts.'
    },
    HomeFireInsuranceName: {
        id: 'cep.components.sgLobSpecifics.HomeFireInsuranceName',
        defaultMessage: 'HomeFireInsurance'
    },
    HomeFireInsuranceHeader: {
        id: 'cep.components.sgLobSpecifics.HomeFireInsuranceHeader',
        defaultMessage: 'Home Fire Insurance'
    },
    HomeFireInsuranceDescription: {
        id: 'cep.components.sgLobSpecifics.HomeFireInsuranceDescription',
        defaultMessage: 'Read our home fire checklist and discover how to protect your home with the right insurance.'
    },
    HomeSurveillanceName: {
        id: 'cep.components.sgLobSpecifics.HomeSurveillanceName',
        defaultMessage: 'HomeSurveillance'
    },
    HomeSurveillanceHeader: {
        id: 'cep.components.sgLobSpecifics.HomeSurveillanceHeader',
        defaultMessage: 'As safe as houses'
    },
    HomeSurveillanceDescription: {
        id: 'cep.components.sgLobSpecifics.HomeSurveillanceDescription',
        defaultMessage: 'Help protect your valuables and your identity with these simple security measures and surveillance solutions for your home.'
    },
    ShedInsuranceName: {
        id: 'cep.components.sgLobSpecifics.ShedInsuranceName',
        defaultMessage: 'ShedInsurance'
    },
    ShedInsuranceHeader: {
        id: 'cep.components.sgLobSpecifics.ShedInsuranceHeader',
        defaultMessage: 'Choosing the right home insurance for your outbuildings'
    },
    ShedInsuranceDescription: {
        id: 'cep.components.sgLobSpecifics.ShedInsuranceDescription',
        defaultMessage: 'Do you have insurance for your outbuildings? Make sure you have the right cover for the structures in your garden.'
    },
    ReduceEnergyBillsName: {
        id: 'cep.components.sgLobSpecifics.ReduceEnergyBillsName',
        defaultMessage: 'ReduceEnergyBills'
    },
    ReduceEnergyBillsHeader: {
        id: 'cep.components.sgLobSpecifics.ReduceEnergyBillsHeader',
        defaultMessage: 'How to reduce energy bills at home'
    },
    ReduceEnergyBillsDescription: {
        id: 'cep.components.sgLobSpecifics.ReduceEnergyBillsDescription',
        defaultMessage: 'The energy price rise is impacting millions of UK households. So, what changes can we make to keep costs down and reduce energy use at home?'
    },
    CarBanName: {
        id: 'cep.components.sgLobSpecifics.CarBanName',
        defaultMessage: 'CarBan'
    },
    CarBanHeader: {
        id: 'cep.components.sgLobSpecifics.CarBanHeader',
        defaultMessage: '2035 car ban'
    },
    CarBanDescription: {
        id: 'cep.components.sgLobSpecifics.CarBanDescription',
        defaultMessage: 'Are petrol and diesel cars destined for the scrap heap? What will the 2035 car ban mean for motorists?'
    },
    CarMedCondName: {
        id: 'cep.components.sgLobSpecifics.CarMedCondName',
        defaultMessage: 'CarMedCond'
    },
    CarMedCondHeader: {
        id: 'cep.components.sgLobSpecifics.CarMedCondHeader',
        defaultMessage: 'Driving with a medical condition'
    },
    CarMedCondDescription: {
        id: 'cep.components.sgLobSpecifics.CarMedCondDescription',
        defaultMessage: 'Find out which medical conditions have to be declared for car insurance and to the DVLA.'
    },
    MOTName: {
        id: 'cep.components.sgLobSpecifics.MOTName',
        defaultMessage: 'MOT'
    },
    MOTHeader: {
        id: 'cep.components.sgLobSpecifics.MOTHeader',
        defaultMessage: 'How do I get my car ready for the MOT?'
    },
    MOTDescription: {
        id: 'cep.components.sgLobSpecifics.MOTDescription',
        defaultMessage: 'Follow our simple tips to get you through the test and keep the car running.'
    },
    ElectricRoadName: {
        id: 'cep.components.sgLobSpecifics.ElectricRoadName',
        defaultMessage: 'ElectricRoad'
    },
    ElectricRoadHeader: {
        id: 'cep.components.sgLobSpecifics.ElectricRoadHeader',
        defaultMessage: 'Electric road trips'
    },
    ElectricRoadDescription: {
        id: 'cep.components.sgLobSpecifics.ElectricRoadDescription',
        defaultMessage: 'The UK has some of the best road trip destinations in the world. But which road trips are best suited to electric cars and the specific model you have? We\'ve analysed things like distance and availability of charging points along the best roads the UK has to offer.'
    },
    CarExcessName: {
        id: 'cep.components.sgLobSpecifics.CarExcessName',
        defaultMessage: 'CarExcess'
    },
    CarExcessHeader: {
        id: 'cep.components.sgLobSpecifics.CarExcessHeader',
        defaultMessage: 'Your guide to car insurance excess'
    },
    CarExcessDescription: {
        id: 'cep.components.sgLobSpecifics.CarExcessDescription',
        defaultMessage: 'Our guide to what you have to pay in the event of a claim may reveal something that surprises you.'
    },
    DelayedFlightName: {
        id: 'cep.components.sgLobSpecifics.DelayedFlightName',
        defaultMessage: 'DelayedFlight'
    },
    DelayedFlightHeader: {
        id: 'cep.components.sgLobSpecifics.DelayedFlightHeader',
        defaultMessage: 'Delayed flight assistance'
    },
    DelayedFlightDescription: {
        id: 'cep.components.sgLobSpecifics.DelayedFlightDescription',
        defaultMessage: 'Plus and Standard customers can enjoy some quiet time in one of more than 950 airport lounges if your flight Is delayed by one (Plus) or two (Standard) hours.'
    },
    TravelProtectName: {
        id: 'cep.components.sgLobSpecifics.TravelProtectName',
        defaultMessage: 'TravelProtect'
    },
    TravelProtectHeader: {
        id: 'cep.components.sgLobSpecifics.TravelProtectHeader',
        defaultMessage: 'Keeping valuables safe on holiday'
    },
    TravelProtectDescription: {
        id: 'cep.components.sgLobSpecifics.TravelProtectDescription',
        defaultMessage: 'Here\'s how to keep your belongings safe while you\'re away having a great time.'
    },
    TravelGPName: {
        id: 'cep.components.sgLobSpecifics.TravelGPName',
        defaultMessage: 'TravelGP'
    },
    TravelGPHeader: {
        id: 'cep.components.sgLobSpecifics.TravelGPHeader',
        defaultMessage: 'Travel GP service'
    },
    TravelGPDescription: {
        id: 'cep.components.sgLobSpecifics.TravelGPDescription',
        defaultMessage: 'We provide, as standard, unlimited access to online & telephone GP appointments on your holiday with the Saga GP Service.'
    },
    CancelledFlightsName: {
        id: 'cep.components.sgLobSpecifics.CancelledFlightsName',
        defaultMessage: 'CancelledFlights'
    },
    CancelledFlightsHeader: {
        id: 'cep.components.sgLobSpecifics.CancelledFlightsHeader',
        defaultMessage: 'Does travel insurance cover cancelled flights?'
    },
    CancelledFlightsDescription: {
        id: 'cep.components.sgLobSpecifics.CancelledFlightsDescription',
        defaultMessage: 'See how travel insurance might be able to help with delayed and cancelled flights.'
    },
    HolidayChecklistName: {
        id: 'cep.components.sgLobSpecifics.HolidayChecklistName',
        defaultMessage: 'HolidayChecklist'
    },
    HolidayChecklistHeader: {
        id: 'cep.components.sgLobSpecifics.HolidayChecklistHeader',
        defaultMessage: 'Holiday checklist'
    },
    HolidayChecklistDescription: {
        id: 'cep.components.sgLobSpecifics.HolidayChecklistDescription',
        defaultMessage: 'We can help you stay organised and hopefully give you peace of mind - meaning you can get on and enjoy your time away.'
    },
    AddressInfo: {
        id: 'cep.components.sgLobSpecifics.AddressInfo',
        defaultMessage: '{addressLine1} {addressLine2}, {addressLine3}, {city}, {county} {postalCode}'
    },
    VehicleInfo: {
        id: 'cep.components.sgLobSpecifics.VehicleInfo',
        defaultMessage: '{make} {model}, {registrationNumber}'
    },
    DestinationInfo: {
        id: 'cep.components.sgLobSpecifics.DestinationInfo',
        defaultMessage: 'Destination: {destination}'
    },
    AnnualTrip: {
        id: 'cep.components.sgLobSpecifics.AnnualTrip',
        defaultMessage: 'Annual trip'
    },
    MotorName: {
        id: 'cep.components.sgLobSpecifics.MotorName',
        defaultMessage: 'Motor'
    },
    HomeName: {
        id: 'cep.components.sgLobSpecifics.HomeName',
        defaultMessage: 'Home'
    },
    VehicleChange: {
        id: 'cep.components.sgLobSpecifics.VehicleChange',
        defaultMessage: 'Changed car to: {vehicle}'
    },
    RegChange: {
        id: 'cep.components.sgLobSpecifics.RegChange',
        defaultMessage: 'Changed registration number to: {registration}'
    },
    ModificationAdded: {
        id: 'cep.components.sgLobSpecifics.ModificationAdded',
        defaultMessage: 'Added modification: {modification}'
    },
    ModificationRemoved: {
        id: 'cep.components.sgLobSpecifics.ModificationRemoved',
        defaultMessage: 'Removed modification: {modification}'
    },
    MileageChange: {
        id: 'cep.components.sgLobSpecifics.MileageChange',
        defaultMessage: 'Changed mileage to: {mileage}'
    },
    VehicleUseChange: {
        id: 'cep.components.sgLobSpecifics.VehicleUseChange',
        defaultMessage: 'Changed use of car to: {use}'
    },
    VehicleParkingChange: {
        id: 'cep.components.sgLobSpecifics.VehicleParkingChange',
        defaultMessage: 'Changed parking type to: {parking}'
    },
    DriverAdded: {
        id: 'cep.components.sgLobSpecifics.DriverAdded',
        defaultMessage: 'Driver added: {driver}'
    },
    DriverRemoved: {
        id: 'cep.components.sgLobSpecifics.DriverRemoved',
        defaultMessage: 'Removed driver: {driver}'
    },
    CoverageAdded: {
        id: 'cep.components.sgLobSpecifics.CoverageAdded',
        defaultMessage: 'Added {coverage}'
    },
    CoverageRemoved: {
        id: 'cep.components.sgLobSpecifics.CoverageRemoved',
        defaultMessage: 'Removed {coverage}'
    }
});
